import {
  Box,
  colors,
  Typography,
  TypographyProps,
  styled,
} from '@mui/material';
import Image from '~/components/Image';

export const BrandImage = styled(Image)`
  object-fit: contain;
  height: 128px;
  width: 128px;
`;

export const ContentContainer = styled(Box)`
  max-width: 1200px;
  margin: 0 auto;
  padding-left: clamp(20px, 4vw, 40px);
  padding-right: clamp(20px, 4vw, 40px);
`;

export const SectionHead = styled(Box)`
  margin-bottom: 40px;
`;

export const Kicker = styled(Typography)`
  display: inline-block;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.blue[700]};
  margin-bottom: 12px;
` as typeof Typography;

export const SectionH2 = styled(Typography)`
  font-size: clamp(28px, 3.4vw, 38px);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin: 0;
  color: ${colors.grey[900]};
` as typeof Typography;

export const SectionHeadRow = styled(Box)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 40px;

  .design-link {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: ${colors.blue[700]};
  }
`;

export const HeroSectionRoot = styled(Box)`
  position: relative;
  overflow: hidden;
  padding: 88px 0 72px;
  background: radial-gradient(
    ellipse 80% 60% at 50% -10%,
    ${colors.blue[50]} 0%,
    transparent 60%
  );
`;

export const HeroGridOverlay = styled(Box)`
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(to right, rgba(0, 0, 0, 0.04) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(0, 0, 0, 0.04) 1px, transparent 1px);
  background-size: 64px 64px;
  mask-image: radial-gradient(
    ellipse 80% 70% at 50% 30%,
    black 30%,
    transparent 80%
  );
  -webkit-mask-image: radial-gradient(
    ellipse 80% 70% at 50% 30%,
    black 30%,
    transparent 80%
  );
  opacity: 0.7;
`;

export const HeroInner = styled(Box)`
  position: relative;
  max-width: 920px;
  margin: 0 auto;
  padding: 0 clamp(20px, 4vw, 40px);
  text-align: center;
`;

export const EyebrowBadge = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid ${colors.grey[200]};
  font-size: 12px;
  font-weight: 500;
  color: ${colors.grey[600]};
`;

export const PulsingDot = styled(Box)`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: ${colors.green[500]};
  flex-shrink: 0;

  @keyframes heroPulse {
    0%,
    100% {
      opacity: 1;
      box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.5);
    }
    50% {
      opacity: 0.55;
      box-shadow: 0 0 0 6px transparent;
    }
  }

  animation: heroPulse 1.6s ease-in-out infinite;
`;

export const DisplayHeadline = styled(Typography)<TypographyProps>`
  margin: 20px 0 16px;
  font-size: clamp(40px, 6vw, 68px);
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.05;
  color: ${colors.grey[900]};
`;

export const LedeText = styled(Typography)`
  margin: 0 auto 36px;
  max-width: 620px;
  font-size: clamp(16px, 1.6vw, 18px);
  line-height: 1.55;
  color: ${colors.grey[600]};
` as typeof Typography;
